export const ATTRACT = 'ATTRACT';
export const BUILD = 'BUILD';
export const CONTROL = 'CONTROL';
export const RESOLVE = 'RESOLVE';
export const CONNECT = 'CONNECT';
export const ORGANIZE = 'ORGANIZE';
export const featureSubCategories = [ATTRACT, BUILD, CONTROL, RESOLVE, CONNECT, ORGANIZE];